"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon16 = Icon16;
exports.Icon20 = Icon20;
exports.Icon24 = Icon24;
exports.Icon40 = Icon40;
exports.Icon60 = Icon60;
exports.Icon8 = Icon8;
exports.IconLogo = IconLogo;
exports.svgIconWrapper = svgIconWrapper;
var _core = require("@blueprintjs/core");
var React = _interopRequireWildcard(require("react"));
var _classes = require("../../common/classes");
var _colors = require("../../common/colors");
var _iconSvgPaths = require("./iconSvgPaths");
var _excluded = ["icon", "fill", "fillOpacity", "style"],
  _excluded2 = ["icon", "fill", "fillOpacity", "style"],
  _excluded3 = ["icon", "fill", "fillOpacity", "style"],
  _excluded4 = ["icon", "fill", "fillOpacity", "style"],
  _excluded5 = ["icon", "fill", "fillOpacity", "style"],
  _excluded6 = ["icon", "style", "stroke"],
  _excluded7 = ["icon", "size", "style"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function Icon8(_ref) {
  var icon = _ref.icon,
    fill = _ref.fill,
    fillOpacity = _ref.fillOpacity,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  var iconArgs = {
    path: _iconSvgPaths.iconSvgPaths8[icon],
    iconSize: 8,
    nativeIconSize: 8,
    fill: fill,
    fillOpacity: fillOpacity,
    style: style
  };
  return /*#__PURE__*/React.createElement(_core.Icon, _extends({
    icon: svgIconWrapper(iconArgs)
  }, props));
}
function Icon16(_ref2) {
  var icon = _ref2.icon,
    fill = _ref2.fill,
    fillOpacity = _ref2.fillOpacity,
    style = _ref2.style,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var iconArgs = {
    path: _iconSvgPaths.iconSvgPaths16[icon],
    iconSize: 16,
    nativeIconSize: 16,
    fill: fill,
    fillOpacity: fillOpacity,
    style: style
  };
  return /*#__PURE__*/React.createElement(_core.Icon, _extends({
    icon: svgIconWrapper(iconArgs)
  }, props));
}
function Icon20(_ref3) {
  var icon = _ref3.icon,
    fill = _ref3.fill,
    fillOpacity = _ref3.fillOpacity,
    style = _ref3.style,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var iconArgs = {
    path: _iconSvgPaths.iconSvgPaths20[icon],
    iconSize: 20,
    nativeIconSize: 20,
    fill: fill,
    fillOpacity: fillOpacity,
    style: style
  };
  return /*#__PURE__*/React.createElement(_core.Icon, _extends({
    icon: svgIconWrapper(iconArgs)
  }, props));
}
function Icon24(_ref4) {
  var icon = _ref4.icon,
    fill = _ref4.fill,
    fillOpacity = _ref4.fillOpacity,
    style = _ref4.style,
    props = _objectWithoutProperties(_ref4, _excluded4);
  var iconArgs = {
    path: _iconSvgPaths.iconSvgPaths24[icon],
    iconSize: 24,
    nativeIconSize: 24,
    fill: fill,
    fillOpacity: fillOpacity,
    style: style
  };
  return /*#__PURE__*/React.createElement(_core.Icon, _extends({
    icon: svgIconWrapper(iconArgs)
  }, props));
}
function Icon40(_ref5) {
  var icon = _ref5.icon,
    fill = _ref5.fill,
    fillOpacity = _ref5.fillOpacity,
    style = _ref5.style,
    props = _objectWithoutProperties(_ref5, _excluded5);
  var iconArgs = {
    path: _iconSvgPaths.iconSvgPaths40[icon],
    iconSize: 40,
    nativeIconSize: 40,
    fill: fill,
    fillOpacity: fillOpacity,
    style: style
  };
  return /*#__PURE__*/React.createElement(_core.Icon, _extends({
    icon: svgIconWrapper(iconArgs)
  }, props));
}
function Icon60(_ref6) {
  var icon = _ref6.icon,
    style = _ref6.style,
    strokeOverride = _ref6.stroke,
    props = _objectWithoutProperties(_ref6, _excluded6);
  var iconArgs = {
    path: _iconSvgPaths.iconSvgPaths100[icon],
    iconSize: 60,
    nativeIconSize: 100,
    fill: 'none',
    fillOpacity: undefined,
    style: style,
    stroke: strokeOverride || _colors.Colors.IVORY_20
  };
  return /*#__PURE__*/React.createElement(_core.Icon, _extends({
    icon: svgIconWrapper(iconArgs)
  }, props));
}
function IconLogo(_ref7) {
  var icon = _ref7.icon,
    size = _ref7.size,
    style = _ref7.style,
    props = _objectWithoutProperties(_ref7, _excluded7);
  var iconArgs = {
    path: _iconSvgPaths.iconSvgPathsLogo[icon],
    iconSize: size || 40,
    nativeIconSize: 16,
    fill: 'none',
    fillOpacity: undefined,
    style: style
  };
  return /*#__PURE__*/React.createElement(_core.Icon, _extends({
    icon: svgIconWrapper(iconArgs)
  }, props));
}
// https://github.com/palantir/blueprint/issues/2348
function svgIconWrapper(_ref8) {
  var path = _ref8.path,
    iconSize = _ref8.iconSize,
    nativeIconSize = _ref8.nativeIconSize,
    fill = _ref8.fill,
    fillOpacity = _ref8.fillOpacity,
    style = _ref8.style,
    stroke = _ref8.stroke;
  return /*#__PURE__*/React.createElement("svg", {
    className: _classes.Classes.ICON_CUSTOM,
    xmlns: "http://www.w3.org/2000/svg",
    width: iconSize,
    height: iconSize,
    viewBox: "0 0 ".concat(nativeIconSize, " ").concat(nativeIconSize),
    fill: fill,
    fillOpacity: fillOpacity,
    style: style,
    stroke: stroke
  }, path);
}